// Hue order: the style picker lays the colors out in this order.
enum PropertyColor {
	red = "red",
	orange = "orange",
	yellow = "yellow",
	lime = "lime",
	green = "green",
	teal = "teal",
	sky = "sky",
	blue = "blue",
	lavender = "lavender",
	purple = "purple",
	pink = "pink",
	gray = "gray",
}

// Before gh#365 a property took a home page card style — a gradient name. Each reads as the color its
// tile showed in the picker then.
const CARD_STYLE_COLORS: Record<string, PropertyColor> = {
	"red-orange": PropertyColor.red,
	"orange-red": PropertyColor.orange,
	"bright-orange": PropertyColor.orange,
	"dark-orange": PropertyColor.yellow,
	"orange-green": PropertyColor.yellow,
	"red-green": PropertyColor.yellow,
	"green-orange": PropertyColor.lime,
	"blue-green": PropertyColor.green,
	"pink-blue": PropertyColor.blue,
	"purple-blue": PropertyColor.blue,
	"blue-purple": PropertyColor.lavender,
	"pink-purple": PropertyColor.purple,
	"purple-orange": PropertyColor.purple,
	"blue-pink": PropertyColor.pink,
	black: PropertyColor.gray,
};

const PROPERTY_COLORS: string[] = Object.values(PropertyColor);

export const toPropertyColor = (style: string): PropertyColor | undefined =>
	PROPERTY_COLORS.includes(style) ? (style as PropertyColor) : CARD_STYLE_COLORS[style];

export default PropertyColor;
